export default __webpack_public_path__ + "static/media/Menu.6d4c784e.svg";